<script>
  let { duration = '300ms', offset = 0, tolerance = 0, children } = $props();
  let headerClass = $state('pin');
  let lastHeaderClass = 'pin';
  let y = $state(0);
  let lastY = 0;
  function deriveClass(y = 0, scrolled = 0) {
    if (y < offset) return 'pin';
    if (!scrolled || Math.abs(scrolled) < tolerance) return headerClass;
    const dir = scrolled < 0 ? 'down' : 'up';
    if (dir === 'up') return 'pin';
    if (dir === 'down') return 'unpin';
    return headerClass;
  }
  function updateClass(y = 0) {
    const scrolledPxs = lastY - y;
    const result = deriveClass(y, scrolledPxs);
    lastY = y;
    return result;
  }
  function action(node) {
    node.style.transitionDuration = duration;
  }
  $effect(() => {
    headerClass = updateClass(y);
    lastHeaderClass = headerClass;
  });
</script>

<svelte:window bind:scrollY={y} />
<div use:action class="{headerClass} header">
  {@render children?.()}
</div>

<style>
  div {
    position: fixed;
    width: 100%;
    top: 0;
    transition: transform 300ms ease-in;
    z-index: 10;
  }
  .pin {
    transform: translateY(0%);
  }
  .unpin {
    transform: translateY(-100%);
  }
</style>
